import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5f1021b0")

_pushScopeId("data-v-5f1021b0")
const _hoisted_1 = { class: "update bg-primary t-center" }
const _hoisted_2 = { class: "t-right p-8" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("New Version detected")
const _hoisted_4 = { class: "mt-16" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "wedge",
  style: {"height":"46px"}
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Update Now")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Pic = _resolveComponent("Pic")
  const _component_t = _resolveComponent("t")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("p", _hoisted_2, [
      _createVNode(_component_Icon, {
        name: "close",
        class: "c-primary",
        style: {"background":"white","border-radius":"12px"},
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      })
    ]),
    _createVNode(_component_Pic, {
      src: "rocket",
      width: "40",
      height: "40"
    }),
    _createVNode(_component_t, {
      as: "p",
      path: "newversion_2",
      class: "f-lg mt-24"
    }, {
      default: _withId(() => [
        _hoisted_3
      ]),
      _: 1
    }),
    _createVNode("p", _hoisted_4, _toDisplayString(_ctx.config.content || 'Experience improve'), 1),
    _hoisted_5,
    _createVNode(_component_t, {
      as: "div",
      path: "newversion_3",
      class: "button f-lg f-bold",
      onClick: _ctx.update
    }, {
      default: _withId(() => [
        _hoisted_6
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
})